import { render, staticRenderFns } from "./GroupsSettingsMain.vue?vue&type=template&id=1a458634&scoped=true&"
import script from "./GroupsSettingsMain.vue?vue&type=script&lang=js&"
export * from "./GroupsSettingsMain.vue?vue&type=script&lang=js&"
import style0 from "./GroupsSettingsMain.vue?vue&type=style&index=0&id=1a458634&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a458634",
  null
  
)

export default component.exports